/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { EngagementFile } from '../models';
import { EngagementFileResponseDto } from '../models';
/**
 * EngagementFilesApi - axios parameter creator
 * @export
 */
export const EngagementFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes an EngagementFile by it's ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engagementFileControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling engagementFileControllerDelete.');
            }
            const localVarPath = `/api/engagement-files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an S3 download link for an EngagementFile by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engagementFileControllerGetDownloadLink: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling engagementFileControllerGetDownloadLink.');
            }
            const localVarPath = `/api/engagement-files/{id}/download-link`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates an EngagementFile
         * @param {string} fileName 
         * @param {string} engagementId 
         * @param {Blob} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engagementFileControllerUploadForm: async (fileName: string, engagementId: string, file: Blob, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling engagementFileControllerUploadForm.');
            }
            // verify required parameter 'engagementId' is not null or undefined
            if (engagementId === null || engagementId === undefined) {
                throw new RequiredError('engagementId','Required parameter engagementId was null or undefined when calling engagementFileControllerUploadForm.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling engagementFileControllerUploadForm.');
            }
            const localVarPath = `/api/engagement-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }

            if (engagementId !== undefined) { 
                localVarFormParams.append('engagementId', engagementId as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EngagementFilesApi - functional programming interface
 * @export
 */
export const EngagementFilesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes an EngagementFile by it's ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engagementFileControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await EngagementFilesApiAxiosParamCreator(configuration).engagementFileControllerDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets an S3 download link for an EngagementFile by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engagementFileControllerGetDownloadLink(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EngagementFileResponseDto>>> {
            const localVarAxiosArgs = await EngagementFilesApiAxiosParamCreator(configuration).engagementFileControllerGetDownloadLink(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Creates an EngagementFile
         * @param {string} fileName 
         * @param {string} engagementId 
         * @param {Blob} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engagementFileControllerUploadForm(fileName: string, engagementId: string, file: Blob, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EngagementFile>>> {
            const localVarAxiosArgs = await EngagementFilesApiAxiosParamCreator(configuration).engagementFileControllerUploadForm(fileName, engagementId, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EngagementFilesApi - factory interface
 * @export
 */
export const EngagementFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Deletes an EngagementFile by it's ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engagementFileControllerDelete(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return EngagementFilesApiFp(configuration).engagementFileControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an S3 download link for an EngagementFile by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engagementFileControllerGetDownloadLink(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<EngagementFileResponseDto>> {
            return EngagementFilesApiFp(configuration).engagementFileControllerGetDownloadLink(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates an EngagementFile
         * @param {string} fileName 
         * @param {string} engagementId 
         * @param {Blob} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engagementFileControllerUploadForm(fileName: string, engagementId: string, file: Blob, options?: AxiosRequestConfig): Promise<AxiosResponse<EngagementFile>> {
            return EngagementFilesApiFp(configuration).engagementFileControllerUploadForm(fileName, engagementId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EngagementFilesApi - object-oriented interface
 * @export
 * @class EngagementFilesApi
 * @extends {BaseAPI}
 */
export class EngagementFilesApi extends BaseAPI {
    /**
     * 
     * @summary Deletes an EngagementFile by it's ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngagementFilesApi
     */
    public async engagementFileControllerDelete(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return EngagementFilesApiFp(this.configuration).engagementFileControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets an S3 download link for an EngagementFile by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngagementFilesApi
     */
    public async engagementFileControllerGetDownloadLink(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<EngagementFileResponseDto>> {
        return EngagementFilesApiFp(this.configuration).engagementFileControllerGetDownloadLink(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Creates an EngagementFile
     * @param {string} fileName 
     * @param {string} engagementId 
     * @param {Blob} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngagementFilesApi
     */
    public async engagementFileControllerUploadForm(fileName: string, engagementId: string, file: Blob, options?: AxiosRequestConfig) : Promise<AxiosResponse<EngagementFile>> {
        return EngagementFilesApiFp(this.configuration).engagementFileControllerUploadForm(fileName, engagementId, file, options).then((request) => request(this.axios, this.basePath));
    }
}
